// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
import ElementUI from 'element-ui'
import store from './store'
import {
  getToken, removeUser,
  toLogin
} from 'chaos-sso-util'
import 'element-ui/lib/theme-chalk/index.css'
// 引入video-Player组件及样式
import VideoPlayer from 'vue-video-player'
import 'videojs-flash'
import 'videojs-contrib-hls'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VideoPlayer)
// axios注册在VUE原型上
Vue.prototype.$axios = axios
const CALL_PAGE_NAME = 'codeCallback'
// 路由登录校验
router.beforeEach((to, from, next) => {
  const token = getToken()
  if (to.name === CALL_PAGE_NAME) {
    next() // 跳转
  } else if (!token) {
    toLogin()
  } else if (to.matched.some(record => record.meta.requireAuth)) {
    // 判断当前的token是否存在
    if (token) {
      next()
    } else {
      next({
        path: '/'
      })
    }
  } else {
    next()
  }
})
// axios响应拦截各种状态码
axios.interceptors.response.use(
  response => {
    if (response.data.total) {
      return response.data
    } else {
      let data = response.data
      let status = response.data.code
      if (data && status) {
        let _status = parseInt(status)
        if (_status === 401) {
          toLogin()
        } else {
          return data.data
        }
      }
    }
  },
  error => {
    if (error && error.response) {
      let response = error.response;
      if (response.data.code === 401) {
        toLogin()
      } else {
        ElementUI.Message.error(response.data.msg)
      }
    } else {
      return Promise.reject(error)
    }
  }
)
store.dispatch('getUserInfo').then(() => {
})
// axios请求拦截添加Token
axios.interceptors.request.use(
  config => {
    let authToken = getToken()
    if (authToken) {
      config.headers[process.env.VUE_APP_SSO_HEADER_TOKEN] = authToken
    }
    return config
  },
  error => {
    return Promise.reject(error.response.data)
  }
)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js